// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export { RefreshControl } from "react-native-web-refresh-control";
